<template>
  <rect x="13" y="2" width="11" height="1" transform="rotate(90 13 2)" fill="#A6A6A6" />
  <rect x="11" y="7" width="1" height="2" transform="rotate(90 11 7)" fill="#A6A6A6" />
  <rect x="8" y="7" width="1" height="2" transform="rotate(90 8 7)" fill="#A6A6A6" />
  <rect x="5" y="7" width="1" height="2" transform="rotate(90 5 7)" fill="#A6A6A6" />
</template>
